import React from 'react';
import { withSvg } from './Svg';

const SvgPin = () => (
  <path d="M5.99935 6.99967C5.26602 6.99967 4.66602 6.39967 4.66602 5.66634C4.66602 4.93301 5.26602 4.33301 5.99935 4.33301C6.73268 4.33301 7.33268 4.93301 7.33268 5.66634C7.33268 6.39967 6.73268 6.99967 5.99935 6.99967ZM9.99935 5.79967C9.99935 3.37967 8.23268 1.66634 5.99935 1.66634C3.76602 1.66634 1.99935 3.37967 1.99935 5.79967C1.99935 7.35967 3.29935 9.42634 5.99935 11.893C8.69935 9.42634 9.99935 7.35967 9.99935 5.79967ZM5.99935 0.333008C8.79935 0.333008 11.3327 2.47967 11.3327 5.79967C11.3327 8.01301 9.55268 10.633 5.99935 13.6663C2.44602 10.633 0.666016 8.01301 0.666016 5.79967C0.666016 2.47967 3.19935 0.333008 5.99935 0.333008Z" />
);

export default withSvg(18, 22)(SvgPin);
